// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {MoocsScreenLayout} from 'app_components/screens/landing/moocs'
// @end

// @ADD Component types
interface IMoocsScreenProps {}
interface IMoocsScreenState {}


class MoocsScreen extends Component<IMoocsScreenProps, IMoocsScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IMoocsScreenProps) {
    super(props)
    this.state = {}
  }

  render() {
    return(
      <MoocsScreenLayout/>
    )
  }
}

export default MoocsScreen
